import { Collapse } from "@mantine/core";
import { clsx } from "clsx";
import { DataTableRowExpansionProps } from "./auto-table-row-expansion.types";
import { useRowExpansionStatus } from "../auto-table.hooks";
import { Table } from "../../table";
import { Box } from "../../box";
import styles from "../auto-table.module.scss";

export function DataTableRowExpansion({
    open,
    colSpan,
    content,
    collapseProps,
    rowProps,
    cellProps,
    contentProps,
}: DataTableRowExpansionProps) {
    const { expanded, visible } = useRowExpansionStatus(open, collapseProps?.transitionDuration);

    return visible ? (
        <Table.Tr data-highlighted={expanded} data-expanded={expanded} {...rowProps}>
                <Table.Td
                    {...cellProps}
                    colSpan={colSpan}
                    className={clsx(styles["expansion-cell"], cellProps?.className)}
                >
                    <Collapse in={expanded} {...collapseProps}>
                        <Box {...contentProps} className={clsx(styles["expansion-content"], contentProps?.className)}>
                            {content()}
                        </Box>
                    </Collapse>
                </Table.Td>
            </Table.Tr>
    ) : null;
}
